module.exports = __webpack_public_path__ + "static/img/1-1.30d38af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-1/1-1.jpg
// module id = 725
// module chunks = 1